import { Environment } from './type';

export const environment: Environment = {
  awsRegion: 'eu-central-1',
  awsUserPoolId: 'eu-central-1_fs8FXM04p',
  awsUserPoolWebClientId: '32qqpvium6qpq27o390mh19ont',
  adminUrl: 'https://stage-admin.volubus.com',
  apiUrl: '/api/v1',
};
